// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"CategoryCoinTable_tableWrapper__c1HB6"};